module.exports = __webpack_public_path__ + "static/media/lykke14.29e4c4d4.jpg";